module.exports = __webpack_public_path__ + "static/media/tree_roots.8225e2b4.png";